module.exports = __webpack_public_path__ + "img/order_confirmed.dd992a03.svg";